// Кто сейчас занимает правый нижний угол экрана (OXEM-760).
//
// Кнопку «Поддержка» рисует загрузчик портала, и её отступ снизу задаётся один
// раз при подключении — двигать её вслед за нашими плашками нельзя. Поэтому
// плавающие элементы сервиса, которые встают в тот же угол (мини-плеер,
// карточка пробного периода, плашка новой версии, нижняя панель действия),
// на время показа заявляют себя здесь, и кнопка прячется, пока заявка жива.
//
// Счётчик, а не флаг: плашек может быть несколько сразу, и снятие одной не
// должно возвращать кнопку поверх второй.
import { useEffect } from "react";
import { create } from "zustand";

interface SupportWidgetState {
	/** Сколько элементов сервиса сейчас занимают правый нижний угол. */
	obstructions: number;
}

export const useSupportWidgetStore = create<SupportWidgetState>(() => ({ obstructions: 0 }));

/** Пока `active`, кнопка «Поддержка» скрыта: элемент занимает её угол. */
export function useSupportWidgetObstruction(active: boolean): void {
	useEffect(() => {
		if (!active) return undefined;
		useSupportWidgetStore.setState((s) => ({ obstructions: s.obstructions + 1 }));
		return () => {
			useSupportWidgetStore.setState((s) => ({ obstructions: Math.max(0, s.obstructions - 1) }));
		};
	}, [active]);
}
